import React from "react";
import { Form } from "react-final-form";
import { Button, Modal, TextArea, TextInput } from "@truevault/aquilo";
import { requiredString } from "../../util/validation";

export interface EeaContactValues {
  eeaContactName: string;
  eeaContactAddress: string;
  eeaContactEmail: string;
  eeaContactPhone?: string;
}

interface EditEeaContactDialogProps {
  open: boolean;
  onClose: () => void;
  onDone: (values: EeaContactValues) => void;
  values?: Partial<EeaContactValues>;
}

export function EditEeaContactDialog({
  open,
  onClose,
  onDone,
  values = {},
}: EditEeaContactDialogProps) {
  if (!open) return null;

  const handleSubmit = (vals: EeaContactValues) => {
    onClose();
    onDone(vals);
  };

  const validate = (vals: EeaContactValues) => {
    const errors = {} as { [x: string]: string };
    requiredString(vals, "eeaContactName", errors);
    requiredString(vals, "eeaContactAddress", errors);
    requiredString(vals, "eeaContactEmail", errors);
    return errors;
  };

  return (
    <Modal
      title="EEA/UK Contact"
      alignText="left"
      closeButton
      showOverlay
      onClose={onClose}
      contentContainerClasses="w-full"
      contentPadding="px-[24px] pt-5 pb-[4px]"
    >
      <Form
        onSubmit={handleSubmit}
        validate={validate}
        initialValues={values}
        render={({ handleSubmit, valid }) => (
          <form
            onSubmit={handleSubmit}
            className="flex flex-col gap-[6px]"
            style={{ marginRight: "-16px" }}
          >
            <p className="text-[16px] text-neutral-700" style={{ marginTop: "-18px" }}>
              Add your business&rsquo;s EEA/UK contact details below.
            </p>

            <div className="flex flex-col gap-[6px]">
              <TextInput field="eeaContactName" label="Name (required)" required autoFocus />
              <TextArea
                field="eeaContactAddress"
                label="Physical Address (required)"
                required
                rows={4}
              />
              <TextInput field="eeaContactEmail" label="Email (required)" type="email" required />
              <TextInput field="eeaContactPhone" label="Phone Number (optional)" />
            </div>

            <div className="flex justify-end items-center gap-[12px]">
              <Button color="tertiary" onClick={onClose}>
                Cancel
              </Button>
              <Button color="primary" type="submit" disabled={!valid} onClick={() => {}}>
                Save
              </Button>
            </div>
          </form>
        )}
      />
    </Modal>
  );
}
